import { useState, useEffect } from "react";

export default function SplashScreen({ onComplete }) {
  const [showWave1, setShowWave1] = useState(false);
  const [showWave2, setShowWave2] = useState(false);
  const [showWave3, setShowWave3] = useState(false);
  const [typedText, setTypedText] = useState("");
  const [faceRotation, setFaceRotation] = useState(-180);
  const [fadeOut, setFadeOut] = useState(false);

  const fullText = "Voice Capture";

  useEffect(() => {
    // Face spins in
    const spinTimer = setTimeout(() => {
      setFaceRotation(0);
    }, 100);

    // Sound waves appear one by one (boom boom boom)
    const wave1Timer = setTimeout(() => setShowWave1(true), 800);
    const wave2Timer = setTimeout(() => setShowWave2(true), 1100);
    const wave3Timer = setTimeout(() => setShowWave3(true), 1400);

    // Start typing effect
    const typeStartTimer = setTimeout(() => {
      let currentIndex = 0;
      const typeInterval = setInterval(() => {
        if (currentIndex <= fullText.length) {
          setTypedText(fullText.slice(0, currentIndex));
          currentIndex++;
        } else {
          clearInterval(typeInterval);
        }
      }, 80);
    }, 1700);

    // Fade out and complete
    const fadeTimer = setTimeout(() => setFadeOut(true), 3200);
    const completeTimer = setTimeout(() => onComplete(), 3700);

    return () => {
      clearTimeout(spinTimer);
      clearTimeout(wave1Timer);
      clearTimeout(wave2Timer);
      clearTimeout(wave3Timer);
      clearTimeout(typeStartTimer);
      clearTimeout(fadeTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div 
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center transition-opacity duration-500 ${fadeOut ? 'opacity-0' : 'opacity-100'}`}
      style={{ backgroundColor: '#0f1419' }}
    >
      {/* Animated Logo */}
      <div className="flex items-center justify-center mb-4">
        <svg
          viewBox="0 0 140 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: '200px', height: '86px' }}
        >
          {/* Face profile - spins in */}
          <g 
            style={{ 
              transform: `rotateY(${faceRotation}deg)`,
              transformOrigin: 'center',
              transition: 'transform 0.8s ease-out'
            }}
          >
            <path
              d="M20 8
                 Q28 4, 34 8
                 L34 14
                 Q33 17, 33 20
                 L40 32
                 Q43 36, 40 40
                 L37 42
                 Q38 45, 38 48
                 Q37 53, 32 56
                 Q26 59, 18 60"
              stroke="#e8e8e8"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
          </g>
          
          {/* Sound wave 1 - closest to mouth */}
          <path 
            d="M52 46 Q60 42, 60 48 Q60 54, 52 50" 
            stroke="#7c3aed" 
            strokeWidth="3.5" 
            strokeLinecap="round" 
            fill="none"
            style={{
              opacity: showWave1 ? 1 : 0,
              transform: showWave1 ? 'scale(1)' : 'scale(0.5)',
              transformOrigin: 'left center',
              transition: 'all 0.3s ease-out'
            }}
          />
          
          {/* Sound wave 2 - medium */}
          <path 
            d="M68 38 Q84 30, 84 48 Q84 66, 68 58" 
            stroke="#7c3aed" 
            strokeWidth="3.5" 
            strokeLinecap="round" 
            fill="none"
            style={{
              opacity: showWave2 ? 0.6 : 0,
              transform: showWave2 ? 'scale(1)' : 'scale(0.5)',
              transformOrigin: 'left center',
              transition: 'all 0.3s ease-out'
            }}
          />
          
          {/* Sound wave 3 - largest */}
          <path 
            d="M92 28 Q116 16, 116 48 Q116 80, 92 68" 
            stroke="#7c3aed" 
            strokeWidth="3.5" 
            strokeLinecap="round" 
            fill="none"
            style={{
              opacity: showWave3 ? 0.3 : 0,
              transform: showWave3 ? 'scale(1)' : 'scale(0.5)',
              transformOrigin: 'left center',
              transition: 'all 0.3s ease-out'
            }}
          />
        </svg>
      </div>

      {/* Typing text effect */}
      <div className="h-10 flex items-center justify-center">
        <h1 
          className="text-3xl font-bold tracking-wide"
          style={{ 
            fontFamily: 'Manrope, sans-serif',
            color: '#f5f5f5'
          }}
        >
          {typedText}
          <span 
            className="inline-block w-0.5 h-7 ml-1 animate-pulse"
            style={{ 
              backgroundColor: '#7c3aed',
              opacity: typedText.length < fullText.length ? 1 : 0
            }}
          />
        </h1>
      </div>
    </div>
  );
}
